// 瑞士
export default {
  home: {
    minute: 'minuto',
    price_info: '{mianfei} minuti gratuiti, massimo al giorno {currencyName}{fengding}, deposito {currencyName}{yajin}, deposito di noleggio gratuito',
    feature_1: 'Design speciale per la ricarica wireless',
    feature_2: 'Prestito e rimborso universali nazionali',
    feature_3: 'Quattro modalità di ricarica, adatte a tutti i telefoni cellulari',
    submit: 'Ricarica',
    borrow: 'Prendere in prestito',
    inputcodetitle: 'Inserisci il numero del dispositivo sull\'armadietto',
    msg_rentcount: 'Hai attualmente {zujieNum} ordini che non sono chiusi',
    cancel: 'Annulla',
    confirm: 'Conferma',
    msg_fail_title: 'Errore',
    msg_fail_content: 'Noleggio fallito, riprova',
    shoptime: 'Orario di apertura',
    supportrental: 'Supporto al noleggio',
    supportreturn: 'Supporto al ritorno',
    useragreen: 'Clicca per accettare il \'Modulo di autorizzazione al debito delegato Contratto utente Contratto di ricarica',
    privacyagreen: 'Clicca per accettare l\'accordo sulla privacy',
    offline: 'Il dispositivo {devicecode} è offline, contatta il personale presente',
    permissionfail: 'Permesso negato.',
    unbound: 'Il codice QR Mix {devicecode} non è legato al dispositivo',
    nobattery: 'Nessuna batteria disponibile nel dispositivo {devicecode}',
    gomap: 'Visualizza commercianti vicini'
  },
  loginborrow: {
    powerbanktitle: 'Lås upp din MOOVERGYPOWER BANK',
    loginwith: 'Logga in med',
    msg_fail_title: 'Errore',
    msg_fail_user: 'Errore nel recupero delle informazioni utente. Vuoi riprovare?',
    msg_rentcount: 'Hai attualmente {zujieNum} ordini che non sono chiusi',
    msg_fail_support: 'Il sistema non è supportato',
    msg_fail_confirm: 'Conferma',
    msg_fail_retry: 'Riprova',
    msg_fail_cancel: 'Annulla',
    msg_fail_order: 'Impossibile creare l\'ordine di locazione',
    msg_fail_paymod: 'Impossibile ottenere il metodo di pagamento',
    msg_fail_login: 'Accesso fallito',
    Apple: 'Apple',
    otheropt: 'Altre opzioni',
    selectmethod: 'Seleziona il tuo metodo di pagamento',
    paymentdetail: 'Dettagli del metodo di pagamento',
    couponcode: 'Codice coupon',
    rent: 'Conferma pagamento',
    pricing: 'Vedi i prezzi',
    phone: 'Telefono',
    Google: 'Google',
    Facebook: 'Facebook',
    loginfb: 'Accedi con Facebook',
    logingg: 'Accedi con Google',
    captcha_code: 'Codice',
    phonenumber: 'Inserisci il tuo numero di telefono ',
    msg_fail_code: 'Inserisci il codice di verifica',
    msg_fail_phone: 'Inserisci il tuo numero di telefono',
    logout: 'Esci dall\'account',
    savenow: 'Salva ora',
    delete: 'Elimina',
    addcard: 'Inserisci i dettagli della carta',
    msg_fail_content: 'Noleggio fallito, riprova',
    title: 'Conferma l\'autorizzazione',
    policy: 'Politica.',
    term: ' Condizioni d\'uso',
    and: 'e',
    privacy: 'Politica sulla privacy.',
    tips: 'Continuando accetti il nostro ',
    cancel: 'ANNULLA',
    agree: 'ACCETTA',
    openinbrowser: 'Si prega di aprirlo nel browser',
    localtip1: 'Återlämna batteriet till alla MOOV-energistationer',
    localtip2: 'För att lokalisera en station i närheten, konsultera kartan eller scanna QR på kraftbanken.'
  },
  preauth: {
    preauthortitle: 'Informazioni sulla pre-autorizzazione',
    tip1: 'Quando si inizia un noleggio, viene effettuata una pre-autorizzazione sul metodo di pagamento. Questo serve solo per assicurarsi che ci siano fondi sufficienti disponibili per pagare il noleggio.',
    tip2: 'La tua banca potrebbe inviarti una notifica ma non si tratta di un addebito: verrà addebitato solo il prezzo del tuo noleggio.',
    tip3: 'A seconda della banca, potrebbero essere necessarie alcune ore fino a qualche giorno per regolare l\'importo sui tuoi estratti conto, questo è normale.'
  },
  rentcost: {
    rentcosttitle: 'Quanto costa il noleggio?',
    tip1: 'Se non restituisci la batteria esterna entro 48 ore ti verrà addebitata una penale di non restituzione di {currency} {yajin} .',
    tip2: 'La durata è arrotondata alla mezz\'ora più vicina (30 o 60 minuti).',
    tip3: 'Un noleggio di un giorno è di 24 ore a partire dal momento in cui la batteria esterna viene noleggiata.',
    tip4: 'Alcune sedi potrebbero offrire alcune ore gratuite o sconti. Buon divertimento!',
    Days: 'Giorni',
    Hours: 'Ore',
    Minutes: 'Minuti'
  },
  logincode: {
    login: 'Accesso',
    retry: 'Rinvia'
  },
  agreenconfirm: {
    title: 'Conferma l\'autorizzazione',
    policy: 'Politica.',
    term: 'Termini e condizioni di MoovEnergy',
    and: 'e',
    privacy: 'Politica sulla privacy.',
    tips: 'Accetto di ',
    cancel: 'ANNULLA',
    agree: 'ACCETTA'
  },
  login: {
    phonenumber: 'Numero di telefono',
    verificationcode: 'Codice di verifica',
    Rentpowerbank: 'Noleggia una batteria esterna',
    Rentpowerbanktip: 'Inserisci il tuo numero di cellulare per iniziare',
    phone_number: 'Inserisci un numero di cellulare a {0} cifre ',
    captcha_code: 'Codice',
    send_code: 'Invia codice',
    login: 'Accesso',
    agree: 'Cliccando su Accesso, accetti ',
    readme: `Contratto utente`,
    msg_fail_login: 'Accesso fallito',
    msg_success_login: 'Accesso riuscito',
    msg_success_login_code: 'Ricevuto con successo, scarica l\'APP per accedere e utilizzare',
    msg_fail_user: 'Errore nel recupero delle informazioni utente. Vuoi riprovare?',
    no_sms: 'Nessun messaggio di testo ricevuto',
    retry: 'Rinvia',
    receive: 'Richiedi',
    invite_pwd: 'Codice d\'invito',
    vip_agreen_tip: 'Continuando, indichi che accetti il nostro',
    vip_agreen_service: 'Termini di servizio',
    vip_agreen_and: 'e',
    vip_agreen_policy: 'Politica sulla privacy'
  },
  msg: {
    appnolaunched: 'Appen har inte officiellt lanserats ännu',
    none_code: 'Il codice non esiste',
    sms_fail: 'Invio SMS fallito',
    unlogin: 'Non ti sei ancora collegato, per favore accedi',
    msg_fail_title: 'Avvertimento',
    deletecard: 'Sei sicuro di voler cancellare questa carta?',
    loading: 'Caricamento...',
    title: 'Suggerimenti',
    success: 'Operazione riuscita',
    error: 'Errore sconosciuto, riprova più tardi.',
    roleerror: 'Permessi insufficienti, consulta l\'amministratore',
    neterror: 'Connessione di rete fallita. Riprova più tardi',
    confirm: 'Conferma',
    retry: 'Riprova',
    cancel: 'Annulla',
    msg_logout: 'Sei sicuro di voler uscire dal conto?',
    vieworder: 'Visualizza ordine',
    addorselectcard: 'Aggiungi o seleziona un pacchetto carta per continuare',
    success_payment: 'Pagamento effettuato',
    fail_payment: 'Pagamento fallito',
    keyword: 'parola chiave',
    unpaid_order: 'Ci sono ordini non pagati',
    go_pay: 'Vai a pagare',
    no_more: 'niente più',
    noshop: 'Nessun commerciante',
    msg_fail_code: 'Inserisci il codice di verifica',
    msg_fail_phone: 'Inserisci il tuo numero di telefono',
    exceedorder: 'Hai già un ordine in corso di locazione, restituiscilo prima di continuare'
  },
  result: {
    title: 'Noleggio confermato',
    tips: 'Per vedere gli ordini e le altre sedi MoovEnergy, scarica l\'app.',
    download: 'SCARICA',
    msg_result_loading: 'Il risultato del pagamento è in fase di conferma...',
    msg_tips_loading: 'La batteria portatile sta saltando fuori, attendere pazientemente...'
  },
  result_msg: {
    loading: 'Caricamento...',
    refresh: 'Aggiorna'
  },
  nearby: {
    rent: 'Lånebara',
    return: 'Kan returneras',
    here: 'Gå hit'
  }
}
